import { render, staticRenderFns } from "./GetPrimaryAffiliation.vue?vue&type=template&id=210e1592&scoped=true"
import script from "./GetPrimaryAffiliation.vue?vue&type=script&lang=js"
export * from "./GetPrimaryAffiliation.vue?vue&type=script&lang=js"
import style0 from "./GetPrimaryAffiliation.vue?vue&type=style&index=0&id=210e1592&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e1592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VForm,VLayout,VSelect,VTextField})
